<template>
  <div class="footer">
    <!-- <div class="rep container">
      <div class="left">
        <div class="avatar" v-if="accountRep?.name !== 'Membership Services'">
          <img :src="getRepAvatar()" alt="" />
        </div>
        <div class="text">
          <p class="title">YOUR membership services representative</p>
          <p>
            {{ accountRep?.name }} | call or text:
            <a :href="`tel:${accountRep?.phone}`"> {{ accountRep?.phone }}</a>
          </p>
          <p>
            <a :href="`mailto:${accountRep?.email.toLowerCase()}`">
              {{ accountRep?.email }}</a
            >
          </p>
        </div>
      </div>
      <div class="right">
        <a :href="`mailto:${accountRep?.email.toLowerCase()}`">
          <button class="btn btn-primary">
            Contact {{ accountRep?.name }}
          </button></a
        >
      </div>
    </div> -->
  </div>
</template>

<script>
// import { reactive, toRefs, computed, watchEffect, onMounted } from "vue";
// import { useStore } from "vuex";
//
// export default {
//   name: "Footer",
//   data() {
//     return {
//       currentYear: new Date().getFullYear(),
//     };
//   },
//   setup() {
//     const store = useStore();
//     // State
//     const state = reactive({
//       accountRep: computed(() => store.getters["purl/getAccountRep"]),
//     });
//
//     return { ...toRefs(state) };
//   },
// };
</script>

<style lang="scss" scoped>
// .footer {
//   padding: 5px 25px;
//   width: 100%;
//   position: fixed;
//   bottom: 0;
//   // background: theme-var($--ch-theme-secondary);
//   z-index: 22;
//   .rep {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     padding: 0 10em;
//     @include media-breakpoint-down(xl) {
//       padding: 0 8em;
//     }
//     overflow: hidden;
//     @media only screen and (min-width: 578px) and (max-width: 900px)  {
//       padding: 0 2em;
//       flex-direction: column;
//     }
//     p {
//       margin: 0;
//       line-height: 1.6em;
//     }
//     a {
//       color: theme-var($--ch-theme-on-secondary);
//     }
//     .title {
//       color: theme-var($--ch-theme-on-secondary);
//       font-size: 10px;
//     }
//     .left {
//       display: flex;
//       font-family: Roboto;
//       font-size: 14px;
//       align-items: center;
//       justify-content: center;
//       @include media-breakpoint-down(sm) {
//         font-size: 12px;
//         line-height: 1.5em;
//         text-align: center;
//       }
//       font-style: normal;
//       font-weight: 400;
//       line-height: 23px;
//       letter-spacing: 0px;
//       text-align: left;
//       text-transform: uppercase;
//       @include media-breakpoint-down(sm) {
//         flex-direction: column;
//         align-items: center;
//       }
//       .avatar {
//         @include media-breakpoint-down(sm) {
//           display: none;
//         }
//         margin-right: 20px;
//         display: flex;
//         align-items: center;
//         border-radius: 50%;
//         overflow: hidden;
//         height: 50px;
//         width: 50px;
//         img {
//           height: 50px;
//           width: 50px;
//           object-fit: cover;
//         }
//       }
//     }
//   }
// }
</style>
